module.exports = __webpack_public_path__ + "img/comite-nord.5fbe991c.jpg";